<template></template>

<script>
export default {
  name: "FilesMain",
};
</script>

<style scoped></style>
